module.exports = __webpack_public_path__ + "static/media/MK.a9dcd156.png";